import { FeedbackConnector } from './Connectors/FeedbackConnector';
import { NPSSurveyConnector } from './Connectors/NPSSurveyConnector';

type Props = {
  type: 'feedback' | 'poll';
  emotion?: number;
  targetUrl: string;
  siteId: number;
  responseId: string | number;
  widgetId: string | number;
  setIsHoveringMarker: (state: boolean) => void;
};

export const EventMarkerAskTooltip = ({
  type,
  siteId,
  responseId,
  widgetId,
  emotion,
  targetUrl,
  setIsHoveringMarker,
}: Props): JSX.Element => {
  return (
    <div
      onMouseEnter={() => setIsHoveringMarker(true)}
      onMouseLeave={() => setIsHoveringMarker(false)}
    >
      {type === 'feedback' && (
        <FeedbackConnector
          siteId={siteId}
          responseId={responseId}
          widgetId={widgetId}
          targetUrl={targetUrl}
          emotion={emotion}
        />
      )}
      {type === 'poll' && (
        <NPSSurveyConnector
          siteId={siteId}
          responseId={responseId}
          surveyId={widgetId}
          targetUrl={targetUrl}
        />
      )}
    </div>
  );
};
